import $ from 'jquery';

export default class StSideBar {
  init() {
    let that = this;
    $('.rightbar_tri,.mobile_bar_tri').click(function(e){
      e.preventDefault();    
      var st_container_dom = $('.st-container');

      if($(this).hasClass('active'))
      {
        that.resetSlidebar(false);
        return false;
      }

      
      let direction = $(this).data('direction');
      
      if(!st_container_dom.hasClass(direction))
        $('.st-container').removeClass('open_bar_right open_bar_left open_column').addClass($(this).data('direction'));
      else
        $('.st-container').addClass('bar_opened');

      that.resetSlidebar(true);
      $(this).addClass('active');
      $('#'+$(this).data('name')).addClass('sidebar_opened');
      if($(this).data('name')=='side_qrcode'){
        that.load_qrcode();
      }
      that.ls_resize(1);
      return false;
    });

    $('#st-pusher-after,.close_right_side,.side_continue,#st-content-inner-after').click(function(){
          that.resetSlidebar(false);
          return false;
      });
  }
  resetSlidebar(keep_open){

    if(!keep_open)
      $('.st-container').removeClass('open_bar_right open_bar_left open_column bar_opened');
    $('.rightbar_tri,.mobile_bar_tri').removeClass('active');
    $('.sidebar_opened').removeClass('sidebar_opened');
    //stwishlit
    $('.add_to_wishlit.active').removeClass('active');
    this.ls_resize(0);
  }
  load_qrcode(){
    var qr_link = $('#qrcode_box .qrcode_link');
    if(!qr_link.find('img').length && qr_link.find('i').length)
    {
        $('<img/>', {
            src: qr_link.attr('href')
        })
        .load(function() {
            qr_link.find('i').replaceWith($(this));
        });
    }
  }
  ls_resize($do_not_resize){
    // $(window).data('plugin_stellar').refresh(); does not work
    if(typeof(this.ls_timer)!=='undefined')
      clearTimeout(this.ls_timer);
    this.ls_timer = setTimeout(function(){
      $('.ls-wp-container').each(function(){
        if(!$do_not_resize || $(this).hasClass('ls-fullsize'))//bu shi quan ping da kai de shi hou bu resize
          $(this).layerSlider('redraw');
      });  
    }, 800);
  }
}



// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js


// WEBPACK FOOTER //
// ./js/components/st-side-bar.js